"use client";

import * as React from "react";

import * as ProgressPrimitive from "@radix-ui/react-progress";

import { cn } from "@/lib/utils";

function Progress({
  className,
  indicatorClassName,
  value,
  showValue = false,
  ...props
}: React.ComponentProps<typeof ProgressPrimitive.Root> & {
  showValue?: boolean;
  indicatorClassName?: string | undefined;
}) {
  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      className={cn("bg-secondary-100 relative h-3 w-full overflow-hidden rounded-full", className)}
      {...props}
    >
      <ProgressPrimitive.Indicator
        data-slot="progress-indicator"
        className={cn(
          "bg-primary h-full w-full flex-1 rounded-2xl transition-all",
          indicatorClassName
        )}
        style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
      />
      {showValue && (
        <div className="absolute inset-0 flex items-center justify-center text-xs font-medium text-white">
          {Math.round(value || 0)}%
        </div>
      )}
    </ProgressPrimitive.Root>
  );
}

export { Progress };
